import React from "react";

const card = "rounded-xl border border-[#00ff90]/30 bg-[#0d0d0d] shadow-[0_0_12px_#00ff9022]";

function fmt(n) {
  if (n == null) return "—";
  if (n >= 10000000) return `₹${(n/10000000).toFixed(2)}Cr`;
  if (n >= 100000)   return `₹${(n/100000).toFixed(2)}L`;
  return `₹${Number(n).toLocaleString("en-IN")}`;
}

function VarBadge({ pct }) {
  if (pct == null) return <span className="text-white/20">—</span>;
  const pos = pct > 0;
  return (
    <span className={`text-xs ${pos ? "text-[#00ff90]" : "text-red-400"}`}>
      {pos ? "+" : ""}{pct}%
    </span>
  );
}

export default function RunSummary({ totals, variance }) {
  const cells = [
    { label: "Gross Pay",   value: fmt(totals?.gross),      varKey: "grossPct",  color: "#fbbf24" },
    { label: "Deductions",  value: fmt(totals?.deductions), varKey: "dedPct",    color: "#f87171" },
    { label: "Net Pay",     value: fmt(totals?.net),        varKey: "netPct",    color: "#00ff90" },
  ];

  return (
    <div className={card}>
      <div className="px-5 py-4 border-b border-white/5 flex items-center justify-between">
        <span className="text-xs text-[#00ff90]/60 uppercase tracking-widest font-medium">Run Summary</span>
        <span className="text-xs text-white/30">Headcount: {totals?.headcount ?? 0}</span>
      </div>
      <div className="p-5">
        <div className="grid grid-cols-3 gap-4">
          {cells.map(({ label, value, varKey, color }) => (
            <div key={label} className="rounded-lg border border-white/5 bg-white/3 p-4 text-center">
              <p className="text-xl font-bold" style={{ color }}>{value}</p>
              <p className="text-xs text-white/30 mt-0.5">{label}</p>
              {variance && (
                <div className="mt-1 flex items-center justify-center gap-1 text-xs text-white/30">
                  vs last: <VarBadge pct={variance[varKey]} />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}